import { connect } from 'react-redux';
import {Route, Switch, withRouter} from 'react-router-dom';
import { injectIntl, intlShape } from 'react-intl';
import Page from '../../app/components/Page';
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import List from "./List";
import Detail from "./Detail";
import Tracking from "./Tracking";
import GlobalError from "../../app/components/GlobalError";
import {NoMatch} from "../../app/containers/NoMatch";
import Helmet from 'react-helmet';

@injectIntl
export class Orders extends Component {
    static propTypes = {
        children: PropTypes.node,
        intl: intlShape,
    }

    render() {
        const { formatMessage } = this.props.intl;

        return (
            <Page>
                <Helmet title={formatMessage({ id: 'frontend.pagetitle.order' })} />
                <Page.Header />
                <GlobalError />
                <Switch>
                    <Route exact path='/orders' component={List} />
                    <Route exact path='/orders/tracking' component={Tracking} />
                    <Route exact path='/orders/:code' component={Detail} />
                    <Route component={NoMatch}/>
                </Switch>
                <Page.Footer />
            </Page>
        );
    }
}

export default withRouter(connect(() => ({}))(Orders));
